import React from 'react';
const AmplificationIcon = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#3C3F47';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" }, attribute),
        React.createElement("path", { d: "M2.25 11.9999C2.25 6.6152 6.6152 2.25 11.9999 2.25V2.25C17.3847 2.25 21.7499 6.6152 21.7499 11.9999V11.9999C21.7499 17.3847 17.3847 21.7499 11.9999 21.7499V21.7499C6.6152 21.7499 2.25 17.3847 2.25 11.9999V11.9999Z", stroke: stroke, strokeWidth: "1.8" }),
        React.createElement("path", { d: "M12 7.73438L12 16.2656", stroke: stroke, strokeWidth: "1.8", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M7.73438 12H16.2656", stroke: stroke, strokeWidth: "1.8", strokeLinejoin: "round" })));
};
export default AmplificationIcon;
